export default __webpack_public_path__ + "static/media/Help.77c4215e.svg";